/**
 * PV-Anlage (W2-A3, 16.10.2026) — Typen und Texte der Seite „PV-Anlage".
 *
 * Die Typen folgen `GET …/elektro/pv` (PvEndpoints.cs, Pvlauf.cs). Gerechnet wird auf dem Server.
 */

export const PV_SPANNEN_HINWEIS =
  'Keine Auslegung: Im Modell sind weder Module noch Wechselrichter geplant. Modulzahl, Wechselrichter '
  + 'und Ertrag sind Spannen aus der FLB 8.16 auf unbestätigten Vorgaben; die FLB widerspricht sich beim '
  + 'Einspeisekonzept (ELT-80).';

export interface PvKennzahlen {
  leistungKwp: number;
  pvTrafos: number;
  anbindungsteile: number;
  module: number;
  wechselrichter: number;
  feuerwehrschalter: number;
  pruefpunkteOffen: number;
  widersprueche: number;
  befunde: number;
  warnungen: number;
  aufAnnahmen: boolean;
}

export interface PvBemessung {
  leistungKwp: number;
  moduleMin: number;
  moduleMax: number;
  leistungAcKw: number;
  scheinleistungKva: number;
  stromA: number;
  wechselrichterMin: number;
  wechselrichterMax: number;
  ertragMinMwh: number;
  ertragMaxMwh: number;
  rechenweg: string[];
}

export interface PvTrafo {
  kennzeichen: string;
  bezeichnung: string | null;
  mittelspannung: string | null;
  msRaum: string | null;
  bemessungKva: number | null;
  oberspannungV: number | null;
  unterspannungV: number | null;
  kurzschlussspannungProzent: number | null;
  schaltgruppe: string | null;
  verbraucherBedarfW: number;
  auslastungProzent: number | null;
}

export interface PvAbgang {
  trafo: string;
  kennzeichen: string;
  art: string;
  raumnummer: string | null;
  bedarfsleistungW: number | null;
  unterverteiler: number;
}

export interface PvAnbindung {
  bauteilart: string;
  bezeichnung: string;
  typ: string | null;
  raumnummer: string | null;
  verteiler: string | null;
  grund: string;
  datenstand: string;
}

/** erfuellt | offen | widerspruch | hinweis */
export interface PvPruefpunkt {
  nr: number;
  punkt: string;
  status: string;
  modell: string;
  normbezug: string;
}

export interface PvVorgabe {
  feld: string;
  verwendung: string | null;
  wert: string;
  einheit: string | null;
  bestaetigt: boolean;
  herkunft: string;
  normbezug: string | null;
  rueckfall: boolean;
}

export interface PvStand {
  kennzahlen: PvKennzahlen;
  bemessung: PvBemessung;
  trafos: PvTrafo[];
  abgaenge: PvAbgang[];
  anbindung: PvAnbindung[];
  pruefliste: PvPruefpunkt[];
  vorgaben: PvVorgabe[];
  befunde: string[];
  stand: string;
}

/** Text der Prüfliste in der Seite. */
export function pruefstatusText(status: string): string {
  switch (status) {
    case 'erfuellt': return 'erfüllt';
    case 'widerspruch': return 'Widerspruch';
    case 'hinweis': return 'Hinweis';
    default: return 'offen';
  }
}
